import api from '../BaseUrl';
import { clearToken, getRefreshToken, setTokens } from '../auth';

export interface Token {
  access_token: string;
  token_type: string;
  expires_in: number;
  refresh_token: string;
}

const tokenHeaders = {
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
  },
};

export const loginWithPassword = async (
  credentials: { username: string; password: string },
  remember = false
): Promise<Token> => {
  const params = new URLSearchParams({ grant_type: 'password', ...credentials });
  const res = await api.post<Token>('/api/Account/Token', params, tokenHeaders);
  setTokens(res.data.access_token, res.data.refresh_token, remember);
  return res.data;
};

/** Revokes this session's refresh token on the server, then forgets the tokens. */
export const logout = async (): Promise<void> => {
  const refreshToken = getRefreshToken();
  try {
    if (refreshToken) await api.post('/api/Account/Logout', { refresh_token: refreshToken });
  } catch {
    /* the local tokens are removed anyway */
  } finally {
    clearToken();
  }
};

export const changePassword = async (currentPassword: string, newPassword: string): Promise<void> => {
  await api.put('/api/Account/ChangePassword', { currentPassword, newPassword });
};
